import { Box, List, ListItem, styled, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";

export const StyledInlineLink = styled(Link)(({ theme }) => ({
  color: theme.palette.custom.primary,
  fontWeight: theme.typography.fontWeight.bold,
  textDecoration: "underline",
}));

export const StyledTypographyText = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.orderName,
  fontWeight: theme.typography.fontWeight.bold,
  fontSize: theme.typography.base.fontSize,
}));

export const StyledBoxTextInner = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 21px",
  background: theme.palette.custom.white,
  borderRadius: theme.borderRadius.radius.regular,
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  border: theme.borders.highlighted,
}));
export const StyledBoxMain = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));

export const StyledTypographyRol = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeight.bold,
  textAlign: "left",
  color: theme.palette.custom.textColor,
  fontSize: theme.typography.small.fontSize,
}));
export const StyledList = styled(List)(({ theme }) => ({
  color: theme.palette.custom.textColor,
  padding: 0,
  fontSize: theme.typography.mini.fontSize,
  listStyleType: "disc",
  paddingLeft: "20px",
  "& .MuiListItem-root": {
    display: "list-item",
  },
}));
export const StyledListItem = styled(ListItem)(({ theme }) => ({
  padding: 0,
  "& .MuiTypography-root": {
    color: theme.palette.custom.textColor,
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const StyledGrid = styled(Grid)(({ theme }) => ({
  background: "linear-gradient(to left, #0B5FA5, #94C1F5)",
  borderRadius: theme.borderRadius.radius.regular,
}));
export const StyledGridList = styled(Grid)(() => ({
  padding: "26px 30px",
}));
export const StyledLockerItemGrid = styled(Grid)(() => ({
  display: "flex",
  "@media (max-width:1140px)": {
    flexBasis: "100%",
    maxWidth: "100%",
  },
}));
export const StyledBoxDis = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "20px 30px",
  [theme.breakpoints.down("md")]: {
    padding: "15px",
  },
}));
export const StyledBoxFrame = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "12px",
  flexWrap: "wrap",
  padding: "16px",
}));
export const StyledBox = styled(Box)(() => ({
  display: "flex",
  gap: "13px",
  flexWrap: "wrap",
  justifyContent: "center",
}));
export const StyledImageBox = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});
export const StyledInnerBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.white,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  borderRadius: theme.shape.custom.largeRadius,
  padding: "7px 13px",
  flexWrap: "wrap",
  [theme.breakpoints.down("xs")]: {
    padding: "0px",
  },
}));
export const StyledBoxLocker = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
}));
export const StyledIDBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.white,
  display: "flex",
  alignItems: "center",
  gap: "10px",
  borderRadius: theme.shape.custom.largeRadius,
  padding: "10px",
  flexWrap: "wrap",
  justifyContent: "center",
}));
export const LockerExpiryText = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.warning,
  fontSize: theme.typography.chipColor.fontSize,
}));
export const StyledIDText = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeight.bold,
  color: theme.palette.custom.primary,
  fontSize: theme.typography.mini.fontSize,
}));
export const LockerExpiryValue = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeight.bold,
  textAlign: "left",
  color: theme.palette.custom.primary,
  fontSize: theme.typography.mini.fontSize,
}));
export const StyledItemListContainer = styled(Box)(({ theme }) => ({
  border: theme.borders.highlighted,
  borderRadius: theme.borderRadius.radius.regular,
}));
export const StyledAddMoreBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "23px",
  border: " 1px dashed #0B65B5",
  borderRadius: theme.shape.custom.largeRadius,
}));
export const StyledItemsContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: "20px 30px",
  [theme.breakpoints.down("xs")]: {
    padding: "0px 10px",
  },
}));
export const StyledSearchIcon = styled(SearchIcon)(() => ({
  width: "17px",
  height: "17px",
}));

export const StatusBadge = styled(Box)(({ theme, status }) => {
  let backgroundColor = "";
  let borderColor = "";
  let textColor = theme.palette.custom.white;

  if (status === "active") {
    backgroundColor = "#00C046";
    borderColor = "#00C046";
  } else if (status === "disable" || status === "draft") {
    backgroundColor = "#FF8500";
    borderColor = "#FF8500";
  } else if (status === "expired") {
    backgroundColor = "#9C9C9C";
    borderColor = "#9C9C9C";
  }else if (status === "review"){
    backgroundColor = "#FFCC00";
    borderColor = "#FFCC00";
  }

  return {
    display: "inline-flex",
    alignItems: "center",
    alignContent:"center",
    textAlign: "center",
    justifyContent: "center",
    borderRadius: "16px",
    padding: '2px 8px 2px 6px',
    fontSize: "12px",
    fontWeight: 500,
    fontFamily: "Inter, sans-serif !important" , 
    color: textColor,
    backgroundColor,
    border: `1px solid ${borderColor}`,
    gap:4
  };
});
